import React, { Component } from "react";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarStatusProtocoloDs } from "../../DataSources.js";
import {
  DataGrid,
  FilterRow,
  StateStoring,
  Editing,
  Column,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";

const localStorageKey = "cadastroStatusProtocoloGridState";

export default class StatusProtocoloBox extends Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.statusProtocoloDs = criarStatusProtocoloDs();
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.onSelecionado = props.onSelecionado;
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("statusprotocolo/editar/" + e.data.id);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <PaginaToolbar
            titulo="Status de Protocolo"
            novoCb={this.novoStatusProtocolo.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.statusProtocoloDs}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
              columnMinWidth
            >
              <StateStoring
                enabled={true}
                type={"localStorage"}
                storageKey={localStorageKey}
              />
              <FilterRow visible={true} />
              <Editing
                allowDeleting={!this.usadoComoPesquisa}
                allowUpdating={!this.usadoComoPesquisa}
                useIcons={true}
                visible={!this.usadoComoPesquisa}
              />

              <Column
                dataField={"sequencial"}
                alignment={"left"}
              />
              <Column
                dataField={"descricao"}
                caption={"Descrição"}
                alignment={"left"}
              />
              <Column
                alignment={"left"}
                dataField={"situacao"}
                caption={"Situação"}
                customizeText={(cellInfo) => {
                  if (cellInfo.value === 0) return "Nenhum";
                  if (cellInfo.value === 1) return "Recebido";
                  if (cellInfo.value === 2) return "Em andamento";
                  if (cellInfo.value === 3) return "Aguardando Solicitante";
                  if (cellInfo.value === 4) return "Impedido";
                  if (cellInfo.value === 5) return "Finalizado";
                }}
              />
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={[
                  "edit",
                  "delete",
                  {
                    hint: "Selecionar",
                    icon: "repeat",
                    visible: this.usadoComoPesquisa,
                    onClick: this.onSelecionado,
                  },
                ]}
              />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
      </React.Fragment>
    );
  }

  novoStatusProtocolo() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("statusprotocolo/novo");
  }
}
